import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({providedIn: 'root'})
export class NodeConfigurationService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAll() {
    return this.http.get<any[]>('/api/nodeConfiguration/getAll');
  }

  getByNode(machineId:string, hostName:string, nodeType:number) {
    return this.http.post<any>('/api/nodeConfiguration/getByNode', {machineId: machineId, hostName: hostName, nodeConfigurationType: nodeType});
  }

  getWebClientDefaultSettings() {
    return this.http.get<any>('/api/webClientConfig/getWebClientDefaultSettings');
  }

  updateApi(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateApi', nodeConfig);
  }

  updateRuntime(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateRuntime', nodeConfig);
  }

  updateInMemory(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateInMemory', nodeConfig);
  }

  updateScheduler(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateScheduler', nodeConfig);
  }

  updateBatcher(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateBatcher', nodeConfig);
  }

  updateWebClient(nodeConfig) {
    return this.http.post<any>('/api/nodeConfiguration/updateWebClient', nodeConfig);
  }
}
